// map-trajectory 场景模块：ECharts 地图（唯一非纯 SVG 场景）。
// 无 svgRender —— 导出走 encodeEcharts 离屏录制路径。
// Component 懒加载（ECharts ~1MB 独立 chunk，按需加载）。
import { lazy } from 'react'
import type { SceneModule } from '../_shared/types'
import { MapTrajectoryEditor } from './Editor'

const MapTrajectory = lazy(() => import('./MapTrajectory'))

export const module: SceneModule = {
  id: 'map-trajectory',
  Component: MapTrajectory,
  Editor: MapTrajectoryEditor,
}
